import { Dialog, DialogBackdrop, DialogPanel, TransitionChild } from '@headlessui/react';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';
import { FunctionComponent, PropsWithChildren, useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { Header } from 'softcat:components/header.tsx';
import { Sidebar } from 'softcat:components/sidebar.tsx';

export const AppLayout: FunctionComponent<PropsWithChildren> = ({ children }) => {
    const [sidebarOpen, setSidebarOpen] = useState(false);

    const location = useLocation();

    useEffect(() => {
        setSidebarOpen(false);
    }, [location]);

    return (
        <>
            <div>
                <Dialog className="relative z-50 lg:hidden" onClose={setSidebarOpen} open={sidebarOpen}>
                    <DialogBackdrop className="fixed inset-0 bg-gray-900/80 transition-opacity duration-300 ease-linear data-[closed]:opacity-0" transition />

                    <div className="fixed inset-0 flex">
                        <DialogPanel
                            className="relative mr-16 flex w-full max-w-xs flex-1 transform transition duration-300 ease-in-out data-[closed]:-translate-x-full"
                            transition
                        >
                            <TransitionChild>
                                <div className="absolute left-full top-0 flex w-16 justify-center pt-5 duration-300 ease-in-out data-[closed]:opacity-0">
                                    <button
                                        className="-m-2.5 p-2.5"
                                        onClick={() => {
                                            return setSidebarOpen(false);
                                        }}
                                        type="button"
                                    >
                                        <span className="sr-only">Close sidebar</span>
                                        <XMarkIcon aria-hidden="true" className="h-6 w-6 text-white" />
                                    </button>
                                </div>
                            </TransitionChild>
                            <div className="flex grow flex-col gap-y-5 overflow-y-auto bg-gray-900 px-6 pb-4">
                                <nav className="flex flex-1 flex-col">
                                    <Sidebar />
                                </nav>
                            </div>
                        </DialogPanel>
                    </div>
                </Dialog>

                <div className="hidden lg:fixed lg:inset-y-0 lg:z-50 lg:flex lg:w-72 lg:flex-col">
                    <div className="flex grow flex-col gap-y-5 overflow-y-auto border-r border-gray-200 bg-gray-900 px-6 pb-4">
                        <nav className="flex flex-1 flex-col">
                            <Sidebar />
                        </nav>
                    </div>
                </div>

                <div className="lg:pl-72">
                    <div className="sticky top-0 z-40 flex h-16 shrink-0 items-center gap-x-4 border-b border-gray-200 bg-white px-4 shadow-sm sm:gap-x-6 sm:px-6 lg:px-8">
                        <button
                            className="-m-2.5 p-2.5 text-gray-700 lg:hidden"
                            onClick={() => {
                                return setSidebarOpen(true);
                            }}
                            type="button"
                        >
                            <span className="sr-only">Open sidebar</span>
                            <Bars3Icon aria-hidden="true" className="h-6 w-6" />
                        </button>

                        <div aria-hidden="true" className="h-6 w-px bg-gray-200 lg:hidden" />

                        <div className="flex flex-1 gap-x-4 self-stretch lg:gap-x-6">
                            <Header />
                        </div>
                    </div>

                    <main className="py-10" data-testid="content">
                        <div className="px-4 sm:px-6 lg:px-8">{children}</div>
                    </main>
                </div>
            </div>
        </>
    );
};
